import {TTableActions} from './table-actions.type';

//#region INTERFACE ITableNavSettings
export interface ITableNavSettings {
  enterEnd: TTableActions;
  tabEnd: TTableActions;
  cellDebounce?: number;
}
//#endregion
